// extracted by mini-css-extract-plugin
module.exports = {"table-header":"components-MUITable-MUITable__table-header--3Vasx"};